import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const cleansingCategoriesEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-cleansing-categories" */ './CleansingCategories.tsx'),
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
